<template>
  <div
    class="reminder"
    @click="toggleRemind"
    :class="{ active: taskInfo.secKillRemainStatus === 1 }"
  >
    <i class="round"></i>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { setCreditsSecKillRemain } from '@/utils/service'

export default {
  name: 'Reminder',
  data() {
    return {
      timeID: null, //防抖timeID
    }
  },
  mounted() {},
  methods: {
    ...mapMutations(['switchSignRemind', 'switchSecKillRemind']),
    toggleRemind() {
      this.switchSecKillRemind()
      let that = this
      Report.click({
        value: JSON.stringify({
          evt: '5034',
          moduleid: 8,
          step: this.taskInfo.secKillRemainStatus == 1 ? 0 : 1,
        }),
      })
      // Report.click({
      //   value:
      //     that.taskInfo.secKillRemainStatus == 1
      //       ? '{"evt": "5011"}'
      //       : '{"evt": "5010"}',
      // })

      if (this.timeID != null) {
        clearTimeout(this.timeID)
      }
      this.timeID = setTimeout(() => {
        this._setCreditsSecKillRemain(this.taskInfo.secKillRemainStatus)
      }, 1000)
    },
    async _setCreditsSecKillRemain(status) {
      try {
        const res = await setCreditsSecKillRemain({ status, hideLoading: true })
      } catch (error) {
        console.log(res)
      }
    },
  },
  computed: mapState([
    'userInfo',
    'devicesInfo',
    'isMGTV',
    'isLogin',
    'conf',
    'taskInfo',
  ]),
}
</script>

<style lang="less" scoped>
.reminder {
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
  position: relative;
  top: 6px;
  width: 68px;
  height: 34px;
  border-radius: 17px;
  border: 2px solid #fff;
  background: #F5F5F5;
  .round {
    position: absolute;
    background-color: #ffffff;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    top: 50%;
    transform: translateY(-50%);
    left: 4px;
    transition: all 0.3s;
  }
  &.active {
    background: #ff5f00;
    border: none;
    .round {
      left: 38px;
    }
  }
}
</style>
